// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://new.api.perle-ruhrpott.de/api/', // 'http://localhost:8000/api/', // 
  BASE_URL: 'https://new.api.perle-ruhrpott.de', // 'http://localhost:8000',// 
  DEFAULT_LANG: 'de',
  APP_VERSION: '2.2.0', // change app version to force clear cache
  GOOGLE_COUNTRIES: ["de"], //for google address
  GOOGLE_LOGIN_WEB_CLIENT_ID: '859823298093-18900gof0l7qo9hc6beoab4lorsa7omm.apps.googleusercontent.com',
  FACEBOOK_LOGIN_APP_ID: '2031380743729076',
  // theme configuration
  DEFAULT_PRIMARY_COLOR: '#cc1fb5',
  DEFAULT_PRIMARY_TEXT_COLOR: '#cc8a1f',
  LAST_MADE_CHANGE:'Topping index issue fixed in toppings page, rest of topping checkboxes disable when required topping amount reached'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
